<template>
    <div :id="this.$route.name">
        <card back>
            <template v-slot:header>
                <h4 class="d-inline"> مجوزات</h4>
                <hr />
            </template>
            <template v-slot:content>

              <div class="alert alert-info" style="line-height: 5px;">
                    <h6>
                        راهنمای لایسنس
                    </h6>
                    <p>
                        1_ لایسنس لایه ی یک و سه ی منو را فیلتر میکند
                    </p>
                    <p>
                        2_ شناسه یکتا باید آدرس کامل سایت باشد و در appsetting مشتری به عنوان سایت اول ثبت شده باشد.(Api)
                    </p>
                    <p>
                        3_ لایسنس جدید به هنگام ثبت جایگزین لایسنس قبلی میشود
                    </p>
                    <p>
                        4_ مشتری نباید به فرم تعریف منو دسترسی داشته باشد
                    </p>
                    <p>
                        5_ مشخصه یکتا باید با http باشد
                    </p>
              </div>
              
                <form autocomplete="off">
                <div class="row">
                    <div class="col-md-3 col-12">
                    <small id="LblSoftwareId"> انتخاب نرم افزار </small>
                    <SearchableCombo
                        :edit="false"
                        :grp="0"
                        :code="null"
                        @ResultCombo="GetSoftware"
                        :rownumintable="3"
                        :defaultvalue="DataAxios.TblSoftwareId"
                        :action="'TblCrmCombo/GetSoftware'"
                        :method="'POST'"
                        :idinput="'SoftwareId'"
                        :keyItem="'SoftwareId'"
                        :ClassProps="'required'"
                    >
                    </SearchableCombo>
                    </div>
                    
                    <div class="col-md-3 col-12">
                        <small id="LblTblCostomer">مربوط به مشتری</small>
                        <SearchableCombo
                            :edit="false"
                            :grp="0"
                            :code="null"
                            @ResultCombo="GetResulTblCostomer"
                            :rownumintable="3"
                            :defaultvalue="DataAxios.TblCustomerId"
                            :action="'TblCrmCombo/GetCostomerProduct'"
                            :method="'POST'"
                            :idinput="'TblCostomer'"
                            :keyItem="'TblCostomer'"
                            :ClassProps="'required'"
                        >
                        </SearchableCombo>
                    </div>
                    <div class="col-md-3 col-12">
                        <small id="LblTblContract"> انتخاب قرارداد </small>
                        <SearchableCombo
                        v-if="$store.state.renderComponentCombo"
                        :edit="false"
                        :grp="0"
                        :code="null"
                        @ResultCombo="GetResulContract"
                        :rownumintable="3"
                        :defaultvalue="refGetResulContract"
                        :action="'TblCrmCombo/GetContract/' + DataAxios.TblCustomerId"
                        :method="'POST'"
                        :idinput="'remot'"
                        class="position-relative"
                        :keyItem="'remot'"
                        >
                        </SearchableCombo>
                    </div>
                    <div class="col-md-3 col-12" dir="rtl" >
                        <small id="LblTblCustomerProduct"> انتخاب محصولات </small>
                        <treeselect
                        name="CustomerContract"
                        :multiple="multiple"
                        :clearable="clearable"
                        :searchable="searchable"
                        :open-on-click="openOnClick"
                        :open-on-focus="openOnFocus"
                        :clear-on-select="clearOnSelect"
                        :close-on-select="closeOnSelect"
                        :always-open="alwaysOpen"
                        :append-to-body="appendToBody"
                        :options="options"
                        v-model="value"
                        :normalizer="normalizer"
                        @select="ItemSelected"
                        @deselect="ItemDeselect"
                        >
                        </treeselect>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 col-12">
                            <small id="LblStratDate"> تاریخ شروع</small>
                            <date-picker input-class="required form-control" color="dimgray" type="datetime"  v-model="DataAxios.StratDate" clearable :editable="true" placeholder="تاریخ شروع" ></date-picker>
                        </div>
                        <div class="col-md-3 col-12">
                            <small id="LblEndDate"> تاریخ پایان</small>
                            <date-picker input-class="required form-control" color="dimgray" type="datetime"  v-model="DataAxios.EndDate" clearable :editable="true" placeholder="تاریخ پایان" ></date-picker>
                        </div>
                    <div class="col-md-3 col-12">
                    <small id="LblDeviceIdentifier">مشخصه یکتا</small>
                    <input type="text" class="form-control InputText required" v-model="DataAxios.DeviceIdentifier" dir="ltr" />
                    </div>
                    <div class="col-md-3 col-12">
                    <small id="LblOnline">Online</small>
                    <div class="form-control custom-switch">
                        <input type="checkbox" class="form-control-input InputText m-1" id="Online" v-model="DataAxios.Online"  />
                        <label class="label txt-bnp mr-2" for="Online"> مجوز برخط</label>
                    </div>
                    </div>
                </div>
                 </form>
                <hr />
                <button v-if="$route.params.Status == 'Add'" class="btn btn-success mr-5" @click.prevent="SaveDeta()">ثبت اطلاعات</button>
                <button v-if="$route.params.Status == 'Edit'" class="btn btn-success mr-5" @click.prevent="SaveEditDeta()">ثبت تغییرات</button>
                <button id="btnCancel" class="btn btn-warning m-2" @click.prevent="Cancel()">انصراف</button>
            </template>
        </card>
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import VuePersianDatetimePicker from "vue-persian-datetime-picker"
import Treeselect from '@riophae/vue-treeselect'
export default {
components: { Card,SearchableCombo,datePicker: VuePersianDatetimePicker,Treeselect },
data(){
    return {
        DataAxios:{},
        refGetResulContract: null,
        DataAxiosPost: {
        ArryfildValue: {},
        Method: 'post',
        Action: '',
        Token: this.$session.get('Token'),
        From: 'Body',
      },
      options: [],
      multiple: true,
      clearable: false,
      searchable: true,
      disabled: false,
      openOnClick: true,
      openOnFocus: false,
      clearOnSelect: true,
      closeOnSelect: false,
      alwaysOpen: false,
      appendToBody: false,
      value: [],
      normalizer(node) {
        return {
          id: node.Id,
          label: node.Name,
        }
      },
    }
},
mounted(){
    if (this.$route.params.Status == 'Add') {
        this.DataAxios.TblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
        }
        if (this.$route.params.Status == 'Edit') {
            this.DataAxios = this.$route.params.DataRow
            this.DataAxios.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
            this.$store.state.OldDataForLog = JSON.stringify(this.DataAxios)
        }
},
methods:{
    GetSoftware(data) {
      if (data.id != null) {
        this.DataAxios.TblSoftwareId = data.id
      }
    },
    GetResulTblCostomer(data) {
      if (data.id != null) {
        this.DataAxios.TblCustomerId = data.id
        this.$store.state.renderComponentCombo = false
        this.$nextTick(() => {
          this.$store.state.renderComponentCombo = true
        })
      }
    },
    GetResulContract(val) {
      if (val.id != null) {
        this.DataAxios.TblContractId = val.id

        let DataAxios_GetData = { ArryfildValue: {}, Method: 'post', Action: 'CustomerProduct/GetProductOfContract', Token: this.$session.get('Token') }
        DataAxios_GetData.ArryfildValue.Id = val.id
        this.$PostData(DataAxios_GetData)
          .then((data) => {

            this.options = data
          })
          .finally(() => {
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          })
      }
    },
    SaveDeta() {
      if (this.$ValidForm('Detaillicense')) {
        this.DataAxiosPost.Action = 'license'
        this.DataAxios.LicenseCode=this.value.toString();
        this.DataAxiosPost.ArryfildValue = this.DataAxios
        console.log(this.DataAxiosPost.ArryfildValue);
        this.$PostData(this.DataAxiosPost).then((data) => {
          if (data.status == 'Ok') {
            this.$toasted.success('مجوز با موفقیت ایجاد شد', {
                action: {
                  text: 'بستن',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  },
                },
              })
          }
        });
      }
    },
    Cancel() {
        this.$router.go(-1)
    },
    ItemSelected(node) {
      this.value.push(node)
    },
    ItemDeselect(node) {
      for (let index = 0; index < this.value.length; index++) {
        if (this.value[index].Id == node.Id) {
          this.value.splice(index, 1)
        }
      }
    }
}
}
</script>
<style scoped>

</style>